import React from "react";
import EmptyCircleIcon from "icons/EmptyCircleIcon";
import EmptyCircleIconRed from "icons/EmptyCircleIconRed";
import CheckCircleSmall from "icons/CheckCircleSmall";

export default function DoneToggleButton(props) {
  const {
    isDone,
    isRed,
    disabled,
    handleEmptyCircleClick,
    handleCheckCircleClick,
  } = props;

  function handleFunction() {
    return isDone ? handleCheckCircleClick : handleEmptyCircleClick;
  }

  function icon() {
    if (isDone) {
      return (
        <CheckCircleSmall
          data-cy="toggle-complete"
          onClick={handleCheckCircleClick}
        />
      );
    } else if (isRed) {
      return <EmptyCircleIconRed data-cy="empty-circle-icon" />;
    } else {
      return <EmptyCircleIcon data-cy="empty-circle-icon" />;
    }
  }
  return (
    <button
      className="Done-toggle-button"
      disabled={disabled}
      onClick={handleFunction()}
    >
      {icon()}
    </button>
  );
}
